import React, { useContext } from "react";
import { Text, View } from "@/styles/reactnative";
import { useWindowDimensions } from "@app/hooks";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "@/theme/ThemeProvider";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";
import { formatDecimal4Truncate } from "@/utils/formatDecimal";
import { truncateWithComma } from "@/utils/Truncate";

const HeaderBottomLists = ({ item, index }) => {
  const isMobile = useIsMobile();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  return (
    <View
      style={{
        alignItems: "flex-start",
        width: "100%",
        paddingBottom: width < 1100 ? 10 : 0,
        marginBottom: width < 1100 ? 10 : 0,
      }}
    >
      <Text size={20}>{t(item?.title)}</Text>
      <Text
        size={30}
        style={{
          marginRight: 10,

          fontWeight: "500",
          marginTop: isMobile ? MobileCalVW(24) : 20
        }}
      >
        {truncateWithComma(item?.usd, 4)} USDT
      </Text>
      <Text size={15} style={{marginTop: isMobile ? MobileCalVW(13) : 10}}>
        ≈{truncateWithComma(item?.currencyValue, 4)} {item?.currency}
      </Text>
    </View>
  );
};

export default React.memo(HeaderBottomLists);
